import styled from 'styled-components';

export const ClassName = styled.h3`
  font-weight: bold;
`;

export const ClassViewTable = styled.table`
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-weight: bold;
  width: 100%;

  :not(:last-child) {
    margin-bottom: 20px;  
  }

  th {
    :last-child {
      border-top-right-radius: 4px;
    }
  }

  tr {
    border: 2px solid ${props => props.theme.mainColor};
    :not(:last-child) {
      border-bottom: none;
    }
    :last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  td {
    :nth-last-child(2) {
      border-right: none;
      width: 100%;
    }
    :last-child {
      min-width: initial;
      text-align: right;
      width: 100%;
    }
  }

  td, th {
    color: ${props => props.theme.mainColor};
    padding: 5px 10px;
    min-width: 175px;
    :not(:last-child) {
      border-right: 2px solid ${props => props.theme.mainColor};
    }
  }
`;

